// extracted by mini-css-extract-plugin
export default {"container":"noArticles_container__mOaIv","message":"noArticles_message__2X7x3"};